import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationVersion } from '../../_types/awb';

export const createAccreditationVersion = async (
  accreditationBodyId: string,
  data: AccreditationVersion,
  callback?: (data: AccreditationVersion) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v2/accreditation-bodies/${accreditationBodyId}/versions`;
  const verticalIds = data.verticals?.length ? data.verticals : data.verticalId ? [data.verticalId] : [];
  const body = {
    version: data.version,
    abbreviation: data.abbreviation,
    jurisdictions: data.jurisdictions ?? [],
    nationwide: data.nationwide ?? false,
    verticals: verticalIds,
  };
  await fetcher({
    url,
    method: 'post',
    body,
  })
    .then((responseData) => {
      if (callback) callback(responseData);
    })
    .catch((err) => {
      if (onError) handleError(err, { onError });
    });
};

export const cloneAccreditationVersion = async (
  accreditationBodyId: string,
  id: string,
  data: AccreditationVersion,
  callback?: (data: AccreditationVersion) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v2/accreditation-bodies/${accreditationBodyId}/versions/${id}/clone`;
  const body = {
    abbreviation: data.abbreviation,
    version: data.version,
  };
  await fetcher({
    url,
    method: 'post',
    body,
  })
    .then((responseData) => {
      if (callback) callback(responseData);
    })
    .catch((err) => {
      console.warn('clone err', err);
      if (onError) handleError(err, { onError });
    });
};

export const updateAccreditationVersion = async (
  accreditationBodyId: string,
  id: string,
  data: AccreditationVersion,
  callback?: (data: AccreditationVersion) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v2/accreditation-bodies/${accreditationBodyId}/versions/${id}`;
  const verticalIds = data.verticals?.length ? data.verticals : data.verticalId ? [data.verticalId] : [];
  const body = {
    version: data.version,
    abbreviation: data.abbreviation,
    jurisdictions: data.jurisdictions ?? [],
    nationwide: data.nationwide ?? false,
    verticals: verticalIds,
    status: data.status ?? 'ENABLED',
  };
  await fetcher({
    url,
    method: 'put',
    body,
  })
    .then((data) => {
      if (callback) callback(data);
    })
    .catch((err) => {
      console.warn('update err', err);
      if (onError) handleError(err, { onError });
    });
};

export const destroyAccreditationVersion = async (
  accreditationBodyId: string,
  id: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${id}`;
  await fetcher({
    url,
    method: 'delete',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      console.warn('destroy err', err);
      if (onError) handleError(err, { onError });
    });
};

export const publishAccreditationVersion = async (
  accreditationBodyId: string,
  versionId: string,
  data: {
    jurisdictions: string[];
    republishNotificationRequired: boolean;
  },
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/publish`;
  await fetcher({
    url,
    method: 'post',
    body: data,
  })
    .then((response) => {
      if (callback) callback();
    })
    .catch((err) => {
      console.warn('publish error', err);
      if (onError) handleError(err, { onError });
    });
};
